// (() => {
//   // Detect Lithuanian by URL
//   const isLT = location.pathname === "/lt" || location.pathname.startsWith("/lt/");
//   if (!isLT) return;

//   const DICT = {
//     "Recommended":"Rekomenduojami",
//     "Best Selling": "Perkamiausi",
//     "Price ascending": "Kaina didėjančiai",
//     "Price descending": "Kaina mažėjančiai",
//     "Relevance": "Aktualiausi",
//     "Sort": "Rūšiuoti",

//     "How to Choose a Tuning Kit?": "Kaip išsirinkti čipą?",
//     "Choose Your Motor": "Išsirinkite savo motorą",
//     "Max Speed setting": "Maksimalaus greičio nustatymas",
//     "Limited": "Ribotas",
//     "Unlimited": "Neribotas",
//     "Activation": "Aktyvavimas",
//     "Always ON": "Visada aktyvus",
//     "Turn ON/OFF": "Galima įjungti / išjungti",
//     "Brand": "Prekinis ženklas",
//     "This indicates whether a tuning kit completely removes the speed limit or has a specific speed limitation.":
//       "Tai rodo, ar čipas visiškai pašalina greičio apribojimą, ar turi konkretų greičio apribojimą.",
//     "This indicates whether you always have your tuning kit enabled or if you can turn it off or on.":
//       "Tai rodo, ar čipas visada aktyvus, ar galite jį išjungti arba įjungti.",
//     "When selecting a tuning kit, prioritize choosing your motor first before considering any other factors.":
//       "Renkantis čipą, pirmiausia pasirinkite savo variklį, o tada apsvarstykite kitus veiksnius",
//     "Year": "Metai",
//     "Bike Brand": "Dviračio prekinis ženklas",
//     "Bike model": "Dviračio modelis",
//     "Brake Disc Mounting": "Stabdžių disko montavimas",
//     "Category": "Kategorija",
//     "Clear": "Išvalyti",
//     "Clear All": "Išvalyti visus",
//     "Apply": "Taikyti",
//     "Type": "Tipas",
//     "Off Road": "Neregistruojamas",
//     "Road Legal": "Registruojamas",
//     "Chat on WhatsApp": "Susisiekti WhatsApp",
//     "Call our Shop" : "Skambinti parduotuvei",
//     "Social Media" : "Socialiniai tinklai",

//     "Filter By": "Filtruoti pagal",
//     "Category:": "Kategorija:",
//     "Clear filter by Category": "Išvalyti kategorijos filtrą",

//     "Suspension": "Amortizacija",
//     "Forks": "Šakės",
//     "Shock Absorbers": "Amortizatoriai",
//     "Linkages & Triangles": "Jungtys ir trikampiai",

//     "Brake Components": "Stabdžių komponentai",
//     "Brake Discs": "Stabdžių diskai",
//     "Brake Pads": "Stabdžių kaladėlės",
//     "Brake Levers": "Stabdžių rankenėlės",
//     "Full Brake Systems": "Pilnos stabdžių sistemos",
//     "Other Brake Parts": "Kitos stabdžių dalys",

//     "Drivetrain": "Važiuoklė",
//     "Chain Drive Kits": "Grandinės pavaros rinkiniai",
//     "Chains": "Grandinės",
//     "Sprockets": "Žvaigždės",
//     "Transmision Parts": "Perdavimo dalys",
//     "Axles & Bolts": "Ašys ir varžtai",
//     "Drivetrain Other": "Kitos važiuoklės dalys",
//     "Bearings":"Guoliai",

//     "Body Parts": "Kėbulo dalys",
//     "Frame Modifiers": "Rėmo modifikatoriai",
//     "Steering": "Vairavimas",
//     "Plastics": "Plastikai",
//     "Guards": "Apsaugos",
//     "Seats & Covers": "Sėdynės ir užvalkalai",
//     "Footpegs & Brackets": "Kojų atramos ir laikikliai",
//     "Other": "Kita",

//     "Wheels & Tyres": "Ratai ir padangos",
//     "Wheel Sets": "Ratų komplektai",
//     "Tyres": "Padangos",

//     "Electric Parts": "Elektrinės dalys",
//     "Motors": "Varikliai",
//     "Batteries": "Baterijos",
//     "Chargers": "Įkrovikliai",
//     "Controllers": "Valdikliai",
//     "Switches": "Jungikliai",
//     "Instruments & Displays": "Instrumentai ir ekranai",
//     "Lights": "Šviesos",
//     "Other Electric": "Kitos elektrinės dalys",

//     "Graphic Kits": "Grafikos rinkiniai",

//     "Boots": "Batai",
//     "Clothing Accessories": "Aprangos aksesuarai",
//     "Gloves": "Pirštinės",
//     "Hats": "Kepurės",
//     "Helmets": "Šalmai",
//     "Jackets": "Striukės",
//     "Jerseys": "Džersiai",
//     "Pants": "Kelnės",
//     "Protection": "Apsaugos",
//     "Shorts": "Šortai",
//     "Size": "Dydis",
//     "Pre Order": "Išankstinis užsakymas",

//     "Trouble finding what you need?": "Sunku rasti tai, ko jums reikia?",
//     "Don't be shy, we are always here to help! Please fill the form bellow":
//       "Nedvejokite, mes visada pasiruošę padėti! Užpildykite žemiau esančią formą",
//     "Name": "Vardas",
//     "Email": "El. paštas",
//     "Message": "Žinutė",
//     "Send": "Susisiekti",

//     "SIGN UP AND SAVE": "PRENUMERATA",
//     "Subscribe to get special offers, free giveaways, and once-in-a-lifetime deals.":
//       "Prenumeruokite, kad gautumėte specialius pasiūlymus ir nuolaidas!",
//     "I would like to receive news about:": "Norėčiau gauti naujienas apie:",
//     "Enter your email": "Jūsų el. paštas",

//     "SUBSCRIBE": "PRENUMERUOTI",
//     "Thank you! You've subscribed successfully": "Ačiū! Sėkmingai užsiprenumeravote",
//     "You are already subscribed": "Jūs jau esate užsiprenumeravę",

//     "For the exact delivery date, please contact us": "Dėl tikslios pristatymo datos prašome kreiptis"
//   };

//   const EXCLUDE_SELECTORS = [
//     "script",
//     "style",
//     "noscript",
//     "textarea",
//     "select",
//     "[contenteditable='true']",
//   ];

//   const ATTRS_TO_TRANSLATE = ["placeholder", "aria-label", "title", "alt"];
//   const normalize = (s) => (s || "").replace(/\s+/g, " ").trim();

//   function isExcludedTextNode(node) {
//     const p = node.parentElement;
//     if (!p) return true;
//     return EXCLUDE_SELECTORS.some((sel) => p.closest(sel));
//   }

//   function translateString(s) {
//     const t = normalize(s);
//     return t ? (DICT[t] || null) : null;
//   }

//   function processTextNodes(root) {
//     const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
//     let node;

//     while ((node = walker.nextNode())) {
//       if (isExcludedTextNode(node)) continue;

//       const originalNorm = normalize(node.nodeValue);
//       const replacement = DICT[originalNorm];
//       if (!replacement) continue;

//       node.nodeValue = node.nodeValue.replace(originalNorm, replacement);
//     }
//   }

//   function processAttributes(root) {
//     const selector = ATTRS_TO_TRANSLATE.map(a => `[${CSS.escape(a)}]`).join(",");
//     const elements = root.querySelectorAll ? root.querySelectorAll(selector) : [];

//     for (const el of elements) {
//       for (const attr of ATTRS_TO_TRANSLATE) {
//         const val = el.getAttribute(attr);
//         if (!val) continue;

//         const replacement = translateString(val);
//         if (!replacement) continue;

//         el.setAttribute(attr, replacement);
//       }
//     }
//   }

//   function translateSortOptionsByValue(root = document) {
//     const map = {
//       "manual": "Rekomenduojami",
//       "best-selling": "Perkamiausi",
//       "price-ascending": "Kaina didėjančiai",
//       "price-descending": "Kaina mažėjančiai",
//       "relevance": "Aktualiausi",
//     };

//     root.querySelectorAll(".boost-pfs-filter-top-sorting-select").forEach(select => {
//       if (select.dataset.ltTranslated === "1") return;

//       [...select.options].forEach(option => {
//         const translated = map[option.value];
//         if (translated) {
//           option.textContent = translated;
//         }
//       });

//       select.dataset.ltTranslated = "1";
//     });
//   }

//   function processRoot(root) {
//     processTextNodes(root);
//     processAttributes(root);
//     translateSortOptionsByValue(root);
//   }

//   function run(root = document.body) {
//     if (!document.body) return;
//     processRoot(root);
//   }

//   run();

//   let scheduled = false;
//   const schedule = () => {
//     if (scheduled) return;
//     scheduled = true;
//     requestAnimationFrame(() => {
//       scheduled = false;
//       run();
//     });
//   };

//   const mo = new MutationObserver((mutations) => {
//     let needsRun = false;

//     for (const mutation of mutations) {
//       if (mutation.type === "childList") {
//         needsRun = true;
//         break;
//       }

//       if (mutation.type === "characterData") {
//         needsRun = true;
//         break;
//       }

//       if (mutation.type === "attributes") {
//         needsRun = true;
//         break;
//       }
//     }

//     if (needsRun) schedule();
//   });

//   mo.observe(document.documentElement, {
//     childList: true,
//     subtree: true,
//     characterData: true,
//     attributes: true,
//     attributeFilter: ATTRS_TO_TRANSLATE,
//   });
// })();

// (() => {
//   const isLT = location.pathname === "/lt" || location.pathname.startsWith("/lt/");
//   if (!isLT) return;

//   const ORIGIN = location.origin;
//   const LT_PREFIX = "/lt";
//   const CONTAINERS = ["#SiteHeader", "#NavDrawer"];

//   function shouldSkipHref(href) {
//     if (!href) return true;
//     if (href.startsWith("#")) return true;
//     if (href.startsWith("mailto:") || href.startsWith("tel:") || href.startsWith("javascript:")) return true;
//     return false;
//   }

//   function rewriteToLT(href) {
//     const url = new URL(href, ORIGIN);

//     if (url.origin !== ORIGIN) return null;
//     if (url.pathname === LT_PREFIX || url.pathname.startsWith(LT_PREFIX + "/")) return null;
//     if (url.pathname.startsWith("/cdn") || url.pathname.startsWith("/admin")) return null;

//     url.pathname = (LT_PREFIX + url.pathname).replace(/\/{2,}/g, "/");
//     return url.toString();
//   }

//   function rewriteLinks() {
//     for (const cSel of CONTAINERS) {
//       const container = document.querySelector(cSel);
//       if (!container) continue;

//       container.querySelectorAll("a[href]").forEach(a => {
//         if (a.dataset.ltUrlFixed === "1") return;

//         const href = a.getAttribute("href");
//         if (shouldSkipHref(href)) return;

//         const newHref = rewriteToLT(href);
//         if (!newHref) return;

//         a.setAttribute("href", newHref);
//         a.dataset.ltUrlFixed = "1";
//       });
//     }
//   }

//   rewriteLinks();

//   const mo = new MutationObserver(rewriteLinks);
//   mo.observe(document.documentElement, { childList: true, subtree: true });
// })();
(() => {
  const LANGS = {
    lt: {
      sortMap: {
        "manual": "Rekomenduojami",
        "best-selling": "Perkamiausi",
        "price-ascending": "Kaina didėjančiai",
        "price-descending": "Kaina mažėjančiai",
        "relevance": "Aktualiausi",
      },
      dict: {
        "Recommended":"Rekomenduojami",
        "Best Selling": "Perkamiausi",
        "Price ascending": "Kaina didėjančiai",
        "Price descending": "Kaina mažėjančiai",
        "Relevance": "Aktualiausi",
        "Sort": "Rūšiuoti",

        "How to Choose a Tuning Kit?": "Kaip išsirinkti čipą?",
        "Choose Your Motor": "Išsirinkite savo motorą",
        "Max Speed setting": "Maksimalaus greičio nustatymas",
        "Limited": "Ribotas",
        "Unlimited": "Neribotas",
        "Activation": "Aktyvavimas",
        "Always ON": "Visada aktyvus",
        "Turn ON/OFF": "Galima įjungti / išjungti",
        "Brand": "Prekinis ženklas",
        "This indicates whether a tuning kit completely removes the speed limit or has a specific speed limitation.":
          "Tai rodo, ar čipas visiškai pašalina greičio apribojimą, ar turi konkretų greičio apribojimą.",
        "This indicates whether you always have your tuning kit enabled or if you can turn it off or on.":
          "Tai rodo, ar čipas visada aktyvus, ar galite jį išjungti arba įjungti.",
        "When selecting a tuning kit, prioritize choosing your motor first before considering any other factors.":
          "Renkantis čipą, pirmiausia pasirinkite savo variklį, o tada apsvarstykite kitus veiksnius",
        "Year": "Metai",
        "Bike Brand": "Dviračio prekinis ženklas",
        "Bike model": "Dviračio modelis",
        "Brake Disc Mounting": "Stabdžių disko montavimas",
        "Category": "Kategorija",
        "Clear": "Išvalyti",
        "Clear All": "Išvalyti visus",
        "Apply": "Taikyti",
        "Type": "Tipas",
        "Off Road": "Neregistruojamas",
        "Road Legal": "Registruojamas",
        "Chat on WhatsApp": "Susisiekti WhatsApp",
        "Call our Shop" : "Skambinti parduotuvei",
        "Social Media" : "Socialiniai tinklai",

        "Filter By": "Filtruoti pagal",
        "Category:": "Kategorija:",
        "Clear filter by Category": "Išvalyti kategorijos filtrą",

        "Suspension": "Amortizacija",
        "Forks": "Šakės",
        "Shock Absorbers": "Amortizatoriai",
        "Linkages & Triangles": "Jungtys ir trikampiai",

        "Brake Components": "Stabdžių komponentai",
        "Brake Discs": "Stabdžių diskai",
        "Brake Pads": "Stabdžių kaladėlės",
        "Brake Levers": "Stabdžių rankenėlės",
        "Full Brake Systems": "Pilnos stabdžių sistemos",
        "Other Brake Parts": "Kitos stabdžių dalys",

        "Drivetrain": "Važiuoklė",
        "Chain Drive Kits": "Grandinės pavaros rinkiniai",
        "Chains": "Grandinės",
        "Sprockets": "Žvaigždės",
        "Transmision Parts": "Perdavimo dalys",
        "Axles & Bolts": "Ašys ir varžtai",
        "Drivetrain Other": "Kitos važiuoklės dalys",
        "Bearings":"Guoliai",

        "Body Parts": "Kėbulo dalys",
        "Frame Modifiers": "Rėmo modifikatoriai",
        "Steering": "Vairavimas",
        "Plastics": "Plastikai",
        "Guards": "Apsaugos",
        "Seats & Covers": "Sėdynės ir užvalkalai",
        "Footpegs & Brackets": "Kojų atramos ir laikikliai",
        "Other": "Kita",

        "Wheels & Tyres": "Ratai ir padangos",
        "Wheel Sets": "Ratų komplektai",
        "Tyres": "Padangos",

        "Electric Parts": "Elektrinės dalys",
        "Motors": "Varikliai",
        "Batteries": "Baterijos",
        "Chargers": "Įkrovikliai",
        "Controllers": "Valdikliai",
        "Switches": "Jungikliai",
        "Instruments & Displays": "Instrumentai ir ekranai",
        "Lights": "Šviesos",
        "Other Electric": "Kitos elektrinės dalys",

        "Graphic Kits": "Grafikos rinkiniai",

        "Boots": "Batai",
        "Clothing Accessories": "Aprangos aksesuarai",
        "Gloves": "Pirštinės",
        "Hats": "Kepurės",
        "Helmets": "Šalmai",
        "Jackets": "Striukės",
        "Jerseys": "Džersiai",
        "Pants": "Kelnės",
        "Protection": "Apsaugos",
        "Shorts": "Šortai",
        "Size": "Dydis",
        "Pre Order": "Išankstinis užsakymas",

        "Trouble finding what you need?": "Sunku rasti tai, ko jums reikia?",
        "Don't be shy, we are always here to help! Please fill the form bellow":
          "Nedvejokite, mes visada pasiruošę padėti! Užpildykite žemiau esančią formą",
        "Name": "Vardas",
        "Email": "El. paštas",
        "Message": "Žinutė",
        "Send": "Susisiekti",

        "SIGN UP AND SAVE": "PRENUMERATA",
        "Subscribe to get special offers, free giveaways, and once-in-a-lifetime deals.":
          "Prenumeruokite, kad gautumėte specialius pasiūlymus ir nuolaidas!",
        "I would like to receive news about:": "Norėčiau gauti naujienas apie:",
        "Enter your email": "Jūsų el. paštas",

        "SUBSCRIBE": "PRENUMERUOTI",
        "Thank you! You've subscribed successfully": "Ačiū! Sėkmingai užsiprenumeravote",
        "You are already subscribed": "Jūs jau esate užsiprenumeravę",

        "For the exact delivery date, please contact us": "Dėl tikslios pristatymo datos prašome kreiptis",

        // Omnisend newsletter form on the homepage
        "Your email address": "Jūsų el. pašto adresas",
        "Email field": "El. pašto laukas",
        "Subscribe": "Prenumeruoti",
        "Send me news about:": "Siųskite man naujienas apie:",
        "E-moto": "E-motociklus",
        "E-bike": "E-dviračius",
        "Pick at least one": "Pasirinkite bent vieną",
        "Please enter your email": "Įveskite savo el. pašto adresą",
        "The email address must contain @ and a valid domain": "El. pašto adrese turi būti @ ir tinkamas domenas",
        "Something went wrong!": "Kažkas nepavyko!",
        "You're in.": "Jūs užsiprenumeravote.",
        "Watch your inbox for drops and rider-only deals.": "Sekite savo el. paštą – naujienos ir pasiūlymai tik prenumeratoriams.",
        "You're already subscribed.": "Jūs jau užsiprenumeravote.",
        "Thanks for riding with us.": "Ačiū, kad važiuojate su mumis."
      }
    },

    de: {
      sortMap: {
        "manual": "Empfohlen",
        "best-selling": "Bestseller",
        "price-ascending": "Preis aufsteigend",
        "price-descending": "Preis absteigend",
        "relevance": "Relevanz",
      },
      dict: {
        "Recommended":"Empfohlen",
        "Best Selling": "Bestseller",
        "Price ascending": "Preis aufsteigend",
        "Price descending": "Preis absteigend",
        "Relevance": "Relevanz",
        "Sort": "Sortieren",

        "How to Choose a Tuning Kit?": "Wie wählt man ein Tuning-Kit aus?",
        "Choose Your Motor": "Wählen Sie Ihren Motor",
        "Max Speed setting": "Maximale Geschwindigkeitseinstellung",
        "Limited": "Begrenzt",
        "Unlimited": "Unbegrenzt",
        "Activation": "Aktivierung",
        "Always ON": "Immer aktiv",
        "Turn ON/OFF": "Ein-/Ausschaltbar",
        "Brand": "Marke",
        "This indicates whether a tuning kit completely removes the speed limit or has a specific speed limitation.":
          "Dies zeigt an, ob ein Tuning-Kit die Geschwindigkeitsbegrenzung vollständig aufhebt oder eine bestimmte Geschwindigkeitsbegrenzung hat.",
        "This indicates whether you always have your tuning kit enabled or if you can turn it off or on.":
          "Dies zeigt an, ob Ihr Tuning-Kit immer aktiviert ist oder ob Sie es ein- und ausschalten können.",
        "When selecting a tuning kit, prioritize choosing your motor first before considering any other factors.":
          "Wählen Sie bei der Auswahl eines Tuning-Kits zuerst Ihren Motor aus, bevor Sie andere Faktoren berücksichtigen.",
        "Year": "Jahr",
        "Bike Brand": "Fahrradmarke",
        "Bike model": "Fahrradmodell",
        "Brake Disc Mounting": "Bremsscheibenaufnahme",
        "Category": "Kategorie",
        "Clear": "Löschen",
        "Clear All": "Alles löschen",
        "Apply": "Anwenden",
        "Type": "Typ",
        "Off Road": "Nicht straßenzugelassen",
        "Road Legal": "Straßenzugelassen",
        "Chat on WhatsApp": "Per WhatsApp kontaktieren",
        "Call our Shop" : "Unser Geschäft anrufen",
        "Social Media" : "Soziale Medien",

        "Filter By": "Filtern nach",
        "Category:": "Kategorie:",
        "Clear filter by Category": "Kategoriefilter löschen",

        "Suspension": "Federung",
        "Forks": "Gabeln",
        "Shock Absorbers": "Stoßdämpfer",
        "Linkages & Triangles": "Umlenkungen & Dreiecke",

        "Brake Components": "Bremskomponenten",
        "Brake Discs": "Bremsscheiben",
        "Brake Pads": "Bremsbeläge",
        "Brake Levers": "Bremshebel",
        "Full Brake Systems": "Komplette Bremssysteme",
        "Other Brake Parts": "Weitere Bremsteile",

        "Drivetrain": "Antrieb",
        "Chain Drive Kits": "Kettenantrieb-Kits",
        "Chains": "Ketten",
        "Sprockets": "Ritzel",
        "Transmision Parts": "Getriebeteile",
        "Axles & Bolts": "Achsen & Schrauben",
        "Drivetrain Other": "Weitere Antriebsteile",
        "Bearings":"Lager",

        "Body Parts": "Karosserieteile",
        "Frame Modifiers": "Rahmenmodifikationen",
        "Steering": "Lenkung",
        "Plastics": "Kunststoffteile",
        "Guards": "Schutzteile",
        "Seats & Covers": "Sitze & Bezüge",
        "Footpegs & Brackets": "Fußrasten & Halterungen",
        "Other": "Sonstiges",

        "Wheels & Tyres": "Räder & Reifen",
        "Wheel Sets": "Radsätze",
        "Tyres": "Reifen",

        "Electric Parts": "Elektrische Teile",
        "Motors": "Motoren",
        "Batteries": "Batterien",
        "Chargers": "Ladegeräte",
        "Controllers": "Controller",
        "Switches": "Schalter",
        "Instruments & Displays": "Instrumente & Displays",
        "Lights": "Beleuchtung",
        "Other Electric": "Weitere elektrische Teile",

        "Graphic Kits": "Grafik-Kits",

        "Boots": "Stiefel",
        "Clothing Accessories": "Bekleidungszubehör",
        "Gloves": "Handschuhe",
        "Hats": "Mützen",
        "Helmets": "Helme",
        "Jackets": "Jacken",
        "Jerseys": "Jerseys",
        "Pants": "Hosen",
        "Protection": "Schutz",
        "Shorts": "Shorts",
        "Size": "Größe",
        "Pre Order": "Vorbestellung",

        "Trouble finding what you need?": "Schwierigkeiten, das Richtige zu finden?",
        "Don't be shy, we are always here to help! Please fill the form bellow":
          "Keine Scheu, wir helfen Ihnen gerne weiter! Bitte füllen Sie das untenstehende Formular aus.",
        "Name": "Name",
        "Email": "E-Mail",
        "Message": "Nachricht",
        "Send": "Senden",

        "SIGN UP AND SAVE": "ANMELDEN UND SPAREN",
        "Subscribe to get special offers, free giveaways, and once-in-a-lifetime deals.":
          "Abonnieren Sie, um Sonderangebote, kostenlose Geschenke und exklusive Deals zu erhalten.",
        "I would like to receive news about:": "Ich möchte Neuigkeiten erhalten über:",
        "Enter your email": "Ihre E-Mail-Adresse",

        "SUBSCRIBE": "ABONNIEREN",
        "Thank you! You've subscribed successfully": "Danke! Sie haben sich erfolgreich angemeldet",
        "You are already subscribed": "Sie sind bereits angemeldet",

        "For the exact delivery date, please contact us": "Für das genaue Lieferdatum kontaktieren Sie uns bitte",

        // Omnisend newsletter form on the homepage
        "Your email address": "Ihre E-Mail-Adresse",
        "Email field": "E-Mail-Feld",
        "Subscribe": "Abonnieren",
        "Send me news about:": "Senden Sie mir Neuigkeiten zu:",
        "E-moto": "E-Motos",
        "E-bike": "E-Bikes",
        "Pick at least one": "Wählen Sie mindestens eine Option",
        "Please enter your email": "Bitte geben Sie Ihre E-Mail-Adresse ein",
        "The email address must contain @ and a valid domain": "Die E-Mail-Adresse muss ein @ und eine gültige Domain enthalten",
        "Something went wrong!": "Etwas ist schiefgelaufen!",
        "You're in.": "Sie sind dabei.",
        "Watch your inbox for drops and rider-only deals.": "Achten Sie auf Ihr Postfach – Neuheiten und Angebote nur für Abonnenten.",
        "You're already subscribed.": "Sie sind bereits angemeldet.",
        "Thanks for riding with us.": "Danke, dass Sie mit uns fahren."
      }
    }
  };

  const EXCLUDE_SELECTORS = [
    "script",
    "style",
    "noscript",
    "textarea",
    "select",
    "[contenteditable='true']",
  ];

  const ATTRS_TO_TRANSLATE = ["placeholder", "aria-label", "title", "alt"];
  const LINK_CONTAINERS = ["#SiteHeader", "#NavDrawer"];
  const ORIGIN = location.origin;

  // Language comes from Shopify, not from the URL, so it works on every
  // address: twowheelsempire.lt/, .com/de/, .com/lt-gb/, .com/de-us/ ...
  function getActiveLang() {
    const raw =
      (window.Shopify && window.Shopify.locale) ||
      document.documentElement.getAttribute("lang") ||
      "";
    const code = raw.toLowerCase().split("-")[0];
    return LANGS[code] ? code : null;
  }

  const lang = getActiveLang();
  if (!lang) return;

  const config = LANGS[lang];

  // Address prefix for this market and language, e.g. "" on twowheelsempire.lt,
  // "/de" on .com/de/, "/lt-gb" on .com/lt-gb/. Empty means links need no rewrite.
  function getLangPrefix() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return root.replace(/\/+$/, "");
  }

  const LANG_PREFIX = getLangPrefix();

  const normalize = (s) => (s || "").replace(/\s+/g, " ").trim();

  function isExcludedTextNode(node) {
    const p = node.parentElement;
    if (!p) return true;
    return EXCLUDE_SELECTORS.some((sel) => p.closest(sel));
  }

  function translateString(s) {
    const t = normalize(s);
    return t ? (config.dict[t] || null) : null;
  }

  function processTextNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;

    while ((node = walker.nextNode())) {
      if (isExcludedTextNode(node)) continue;

      const originalNorm = normalize(node.nodeValue);
      const replacement = config.dict[originalNorm];
      if (!replacement) continue;

      node.nodeValue = node.nodeValue.replace(originalNorm, replacement);
    }
  }

  function processAttributes(root) {
    const selector = ATTRS_TO_TRANSLATE.map(a => `[${CSS.escape(a)}]`).join(",");
    const elements = root.querySelectorAll ? root.querySelectorAll(selector) : [];

    for (const el of elements) {
      for (const attr of ATTRS_TO_TRANSLATE) {
        const val = el.getAttribute(attr);
        if (!val) continue;

        const replacement = translateString(val);
        if (!replacement) continue;

        el.setAttribute(attr, replacement);
      }
    }
  }

  function translateSortOptionsByValue(root = document) {
    root.querySelectorAll(".boost-pfs-filter-top-sorting-select").forEach(select => {
      const doneKey = `${lang}Translated`;
      if (select.dataset[doneKey] === "1") return;

      [...select.options].forEach(option => {
        const translated = config.sortMap[option.value];
        if (translated) option.textContent = translated;
      });

      select.dataset[doneKey] = "1";
    });
  }

  function shouldSkipHref(href) {
    if (!href) return true;
    if (href.startsWith("#")) return true;
    if (href.startsWith("?")) return true;
    if (href.startsWith("mailto:")) return true;
    if (href.startsWith("tel:")) return true;
    if (href.startsWith("javascript:")) return true;
    return false;
  }

  function rewriteToLang(href) {
    const url = new URL(href, ORIGIN);

    if (url.origin !== ORIGIN) return null;
    if (url.pathname === LANG_PREFIX || url.pathname.startsWith(LANG_PREFIX + "/")) return null;
    if (url.pathname.startsWith("/cdn") || url.pathname.startsWith("/admin")) return null;

    url.pathname = (LANG_PREFIX + url.pathname).replace(/\/{2,}/g, "/");
    return url.toString();
  }

  function rewriteLinks() {
    if (!LANG_PREFIX) return;

    for (const cSel of LINK_CONTAINERS) {
      const container = document.querySelector(cSel);
      if (!container) continue;

      container.querySelectorAll("a[href]").forEach(a => {
        const doneKey = `${lang}UrlFixed`;
        if (a.dataset[doneKey] === "1") return;

        const href = a.getAttribute("href");
        if (shouldSkipHref(href)) return;

        const newHref = rewriteToLang(href);
        if (!newHref) return;

        a.setAttribute("href", newHref);
        a.dataset[doneKey] = "1";
      });
    }
  }

  function processRoot(root) {
    processTextNodes(root);
    processAttributes(root);
    translateSortOptionsByValue(root);
  }

  function run(root = document.body) {
    if (!document.body) return;
    processRoot(root);
    rewriteLinks();
  }

  run();

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    // setTimeout rather than requestAnimationFrame so tabs opened in the background still translate
    setTimeout(() => {
      scheduled = false;
      run();
    }, 30);
  };

  const mo = new MutationObserver((mutations) => {
    let needsRun = false;

    for (const mutation of mutations) {
      if (mutation.type === "childList") {
        needsRun = true;
        break;
      }

      if (mutation.type === "characterData") {
        needsRun = true;
        break;
      }

      if (mutation.type === "attributes") {
        needsRun = true;
        break;
      }
    }

    if (needsRun) schedule();
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ATTRS_TO_TRANSLATE,
  });

  const linkMo = new MutationObserver(() => rewriteLinks());
  linkMo.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();